import { createStore } from "owa-satcheljs";
import type { MailboxInfo } from "owa-client-types";

interface AddressBookStore {
    mailboxInfo?: MailboxInfo;
    targetWindow?: Window;
    focusTarget?: HTMLElement;
}

export const getAddressBookStore: () => AddressBookStore = createStore<AddressBookStore>("addressBookStore", {
    mailboxInfo: undefined,
    targetWindow: undefined,
    focusTarget: undefined,
});
